import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Paper,
  Divider,
  CircularProgress,
  IconButton,
  Button,
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  ArrowBack as ArrowBackIcon,
  EmojiEvents as TrophyIcon,
} from '@mui/icons-material';
import RankingTable from '../../components/RankingTable';
import PageTitle from '../../components/PageTitle';

const StoreRankingPage = () => {
  const { storeId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [players, setPlayers] = useState([]);
  const [store, setStore] = useState(null);

  useEffect(() => {
    // TODO: Replace with actual API call
    const fetchStoreData = async () => {
      try {
        // Simulated store data
        setStore({
          id: storeId,
          name: 'Warpig Games',
          logo: 'https://images.unsplash.com/photo-1585504198199-20277593b94f?q=80&w=500&auto=format&fit=crop',
          location: 'Palermo, Buenos Aires'
        });

        // Simulated players data with medal colors
        const mockPlayers = [
          { id: 1, name: 'Juan Pérez', torCode: 'TOR001', matches: 25, wins: 20, points: 60, store: 'Warpig Games' },
          { id: 2, name: 'María García', torCode: 'TOR002', matches: 22, wins: 18, points: 54, store: 'Warpig Games' },
          { id: 3, name: 'Carlos López', torCode: 'TOR003', matches: 20, wins: 15, points: 45, store: 'Warpig Games' },
          { id: 4, name: 'Ana Martínez', torCode: 'TOR004', matches: 18, wins: 12, points: 36, store: 'Warpig Games' },
          { id: 5, name: 'Diego Soto', torCode: 'TOR005', matches: 17, wins: 11, points: 33, store: 'Warpig Games' },
          { id: 6, name: 'Laura Torres', torCode: 'TOR006', matches: 16, wins: 10, points: 30, store: 'Warpig Games' },
          { id: 7, name: 'Pedro Rojas', torCode: 'TOR007', matches: 15, wins: 9, points: 27, store: 'Warpig Games' },
          { id: 8, name: 'Carmen Silva', torCode: 'TOR008', matches: 14, wins: 8, points: 24, store: 'Warpig Games' },
          { id: 9, name: 'Jorge Muñoz', torCode: 'TOR009', matches: 13, wins: 7, points: 21, store: 'Warpig Games' },
          { id: 10, name: 'Isabel Castro', torCode: 'TOR010', matches: 12, wins: 6, points: 18, store: 'Warpig Games' },
          { id: 11, name: 'Roberto Díaz', torCode: 'TOR011', matches: 11, wins: 5, points: 15, store: 'Warpig Games' },
          { id: 12, name: 'Patricia Vera', torCode: 'TOR012', matches: 10, wins: 4, points: 12, store: 'Warpig Games' },
          { id: 13, name: 'Miguel Parra', torCode: 'TOR013', matches: 9, wins: 3, points: 9, store: 'Warpig Games' },
          { id: 14, name: 'Daniela Ríos', torCode: 'TOR014', matches: 8, wins: 2, points: 6, store: 'Warpig Games' },
          { id: 15, name: 'Fernando Bravo', torCode: 'TOR015', matches: 7, wins: 1, points: 3, store: 'Warpig Games' },
        ];

        setPlayers(mockPlayers);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching store data:', error);
        setLoading(false);
      }
    };

    fetchStoreData();
  }, [storeId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress sx={{ color: '#c89e38' }} />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <IconButton 
          onClick={() => navigate('/torneos/tiendas')}
          sx={{ 
            width: 40,
            height: 40,
            bgcolor: 'action.hover',
            color: 'text.primary',
            '&:hover': { 
              bgcolor: '#c89e38',
              color: 'white',
              transform: 'scale(1.1)'
            },
            transition: 'all 0.2s ease-in-out'
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
          <Box 
            component="img"
            src={store?.logo}
            alt={store?.name}
            sx={{ 
              width: 50,
              height: 50,
              objectFit: 'contain',
              borderRadius: 1
            }}
          />
          <Box>
            <PageTitle title={store?.name} />
            <Typography variant="body2" color="text.secondary">
              {store?.location}
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          startIcon={<TrophyIcon />}
          onClick={() => navigate(`/torneos/tiendas/${storeId}/resultados`)}
          sx={{ 
            bgcolor: '#c89e38',
            '&:hover': {
              bgcolor: '#b58e28',
            }
          }}
        >
          Ver Partidas
        </Button>
      </Box>
      
      <Paper 
        elevation={0}
        sx={{ 
          p: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2
        }}
      >
        <Typography variant="h6" gutterBottom>
          Ranking de la Temporada
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Ranking actualizado con los resultados de todos los torneos
        </Typography>
        <Divider sx={{ my: 2 }} />
        
        <RankingTable players={players} showStore={false} />
      </Paper>
    </Container>
  );
};

export default StoreRankingPage; 